import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import IconButton from '@mui/material/IconButton'
import Icon from '../icon';

import AddQuotation from './quotation/AddForm'
import DetailQuotation from './quotation/DetailForm'
import { useEffect, useState } from 'react';
import { Box, Button, Tooltip, Typography } from '@mui/material';
import MsiDatagrid from '../custom/MsiDatagridAuto';
import axios from 'axios';
import apiUrl from '../../configs/constant';
import Swal from 'sweetalert2';

interface Props {
    open: boolean
    contact?: {
        id: number
        sdcust_id: number
    }
    onClose: () => void
    onNavigate?: (id) => void
}

export default function DialogQuotation({
    open,
    contact,
    onClose,
    onNavigate
}: Props) {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
    const cabang = JSON.parse(localStorage.getItem('cabang')!)

    const [listData, setListData] = useState<any[]>([])
    const [mode, setMode] = useState<string>('')
    const [selectedId, setSelectedId] = useState<any>(null)
    const [doctag, setDoctag] = useState<any>(null)

    useEffect(() => {
        getData();
    }, [])

    const getData = () => {

        let url = apiUrl.apiUrl + '/sales/quotation/list-by-customer'

        axios
            .get(url, {
                params: {
                    sdcust_id: contact?.sdcust_id,
                    sysdoctag_id: doctag,
                    mode: 0,
                },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListData(data)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const handleDelete = (row: any) => {
        Swal.fire({
            title: 'Konfirmasi',
            text: 'Apakah anda ingin hapus data ini ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#337ab7',
            cancelButtonColor: '#ffc107',
            confirmButtonText: 'Hapus'
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })

                const url = apiUrl.apiUrl + '/sales/quotation/delete/' + row.id
                axios
                    .delete(url, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    })
                    .then(response => {
                        if (response.data.success) {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'success',
                                timer: 1000,
                                timerProgressBar: true,
                                willClose: () => {
                                    getData()
                                }
                            })
                        } else {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'error'
                            })
                        }
                    })
                    .catch(error => {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: error.message,
                            icon: 'error'
                        })
                    })
            }
        })
    };

    const ActionButtons = ({ row, onDelete, onNavigate }: {
        row: any;
        onDelete: (row: any) => void;
        onNavigate: (id: string) => void
    }) => {
        const actions = [
            {
                title: "Lihat Detail",
                icon: "mdi:search",
                color: "primary",
                onClick: () => onNavigate(row.id)
            },
            {
                title: "Print",
                icon: "mdi:printer",
                color: "primary",
                onClick: () => window.open(apiUrl.baseUrl + '/system/print/sdso/' + row.id, '_blank')
            },
            {
                title: "Hapus Quotation",
                icon: "mdi:trash",
                color: "red",
                onClick: () => onDelete(row)
            }
        ];

        return (
            <Box sx={{ display: "flex", alignItems: "center" }}>
                {actions.map(action => (
                    <Tooltip key={action.title} title={action.title} placement="top">
                        <IconButton onClick={action.onClick}>
                            <Icon icon={action.icon} color={action.color} />
                        </IconButton>
                    </Tooltip>
                ))}
            </Box>
        );
    };

    const actionData = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 150,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <ActionButtons
                    row={row}
                    onDelete={handleDelete}
                    onNavigate={(id) => {
                        setSelectedId(id)
                        setMode('detail')
                    }}
                />
            ),
        },
    ];

    return (
        <Dialog
            open={open}
            maxWidth="xl"
            fullWidth
            onClose={onClose}
        >
            <DialogTitle>
                {mode === '' && 'Quotation'}
                {mode === 'add' &&
                    <>
                        <IconButton
                            onClick={() => setMode('')}
                            sx={{ position: 'absolute', left: 10, top: 10 }}
                        >
                            <Icon icon="mdi:chevron-left-circle" />
                        </IconButton>
                        <Typography variant='h5' sx={{ textAlign: 'center' }}>

                            Add Quotation
                        </Typography>
                    </>
                }
                {mode === 'detail' &&
                    <>
                        <IconButton
                            onClick={() => setMode('')}
                            sx={{ position: 'absolute', left: 10, top: 10 }}
                        >
                            <Icon icon="mdi:chevron-left-circle" />
                        </IconButton>
                        <Box>
                            <Typography variant='h5' sx={{ textAlign: 'center' }}>
                                Detail Quotation
                            </Typography>
                            <Typography variant='body1' sx={{ textAlign: 'center' }}>
                                No. Dokumen : <b>{selectedId}</b>
                            </Typography>
                        </Box>
                    </>
                }

                <IconButton
                    onClick={onClose}
                    sx={{ position: 'absolute', right: 10, top: 10 }}
                >
                    <Icon icon="mdi:close" />
                </IconButton>
            </DialogTitle>

            <DialogContent>
                {mode === '' && (
                    <Box>
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                                mb: 1
                            }}
                        >
                            <Button
                                variant="contained"
                                color="primary"
                                startIcon={<Icon icon="mdi:plus" />}
                                onClick={() => {
                                    setMode('add')
                                }}
                            >
                                Buat Quotation
                            </Button>
                        </Box>
                        <MsiDatagrid array={listData} actions={actionData} hiddenColumns={['dokumen', 'sdcust_id', 'is_aktif', 'default_dp', 'default_dp_pesan']} />
                    </Box>
                )}
                {mode === 'add' && (
                    <AddQuotation
                        contact={contact}
                        onClose={onClose}
                        onNavigate={(id) => {
                            setSelectedId(id)
                            setMode('detail')
                        }}
                    />
                )}

                {mode === 'detail' && selectedId && (
                    <DetailQuotation
                        id={selectedId}
                        onClose={onClose}
                    />
                )}

            </DialogContent>
        </Dialog>
    )
}
